import { useMemo } from 'react';
import { DimensionObjectType } from '~/types';

const DIMENSIONS = [
  {
    id: 'primaryRole',
    displayText: 'Primary Role',
    objectType: DimensionObjectType.ProjectRole
  },
  {
    id: 'resource',
    displayText: 'Resource',
    objectType: DimensionObjectType.User
  },
  {
    id: 'payCode',
    displayText: 'Pay Code',
    objectType: DimensionObjectType.PayCode
  },
  {
    id: 'taskRole',
    displayText: 'Task Role',
    objectType: DimensionObjectType.ProjectRole
  }
];

const MUTUALLY_EXCLUSIVE_PAIR = ['primaryRole', 'taskRole'];

export const useAvailableCostOverrideDimensions = ({
  selectedDimensions = []
} = {}) => {
  const availableDimensions = useMemo(() => {
    const selectedIds = new Set(selectedDimensions.map(d => d.id));
    const exclusivePairSelected = MUTUALLY_EXCLUSIVE_PAIR.some(id =>
      selectedIds.has(id)
    );

    return DIMENSIONS.filter(
      d =>
        !selectedIds.has(d.id) &&
        !(MUTUALLY_EXCLUSIVE_PAIR.includes(d.id) && exclusivePairSelected)
    );
  }, [selectedDimensions]);

  return { availableDimensions };
};

export default useAvailableCostOverrideDimensions;
